// extracted by mini-css-extract-plugin
module.exports = {"layout":"a10a3f92e9--layout--b2z0h","spinner":"a10a3f92e9--spinner--tFhXq","container":"a10a3f92e9--container--SQnDh","error":"a10a3f92e9--error--rGEGi"};